import { IconButton, makeStyles, createStyles } from "@material-ui/core";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

export const ArrowCarousel = (props: {
    direction: "left" | "right";
    onClick: () => void;
    disabled?: Boolean;
}) => {
    const classes = useStyles();
    return (
        <IconButton
            onClick={props.onClick}
            disabled={Boolean(props.disabled)}
            size="small"
        >
            {props.direction === "left" ? (
                <KeyboardArrowLeft
                    classes={{ root: classes.icon_button_root }}
                />
            ) : (
                <KeyboardArrowRight
                    classes={{ root: classes.icon_button_root }}
                />
            )}
        </IconButton>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        icon_button_root: {
            color: "white",
            borderRadius: 50,
        },
        "@global": {
            ".MuiIconButton-sizeSmall": {
                height: 20,
                width: 20,
            },
        },
    })
);
